import { IUser, UserModel } from "./user.model";
import * as moment from 'moment';
import { JwtHelperService } from "@auth0/angular-jwt";

const jwtHelper = new JwtHelperService();

export interface IAuth {
  access: string;
  refresh: string;
  user: IUser;
}
export class AuthModel {
  authToken: string;
  expiresIn: moment.Moment;
  user: UserModel;

  setAuth(auth: AuthModel) {
    this.authToken = auth.authToken;
    this.expiresIn = auth.expiresIn;

    this.user = auth.user;
  }

  static fromObject(obj: IAuth): AuthModel {
    let auth = new AuthModel();
    auth.authToken = obj.access;
    auth.user = UserModel.fromObject(obj.user);
    auth.expiresIn = moment(jwtHelper.getTokenExpirationDate(obj.access));
    return auth;
  }
}
